import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7aa0cfb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, [
  /*#__PURE__*/_createElementVNode("div", null, "操作提示："),
  /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"5px"} }, "平台商品评价，管理员可进行对应操作。")
], -1))
const _hoisted_2 = { key: 2 }
const _hoisted_3 = { key: 3 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("隐藏")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("显示")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("删除")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, { title: "商品评价" }, {
      default: _withCtx(() => [
        _hoisted_1,
        _createVNode(_component_a_table, {
          dataSource: _ctx.list,
          columns: $setup.columns,
          bordered: "",
          pagination: $setup.pagination,
          onChange: $setup.handleTableChange,
          style: {"margin-top":"10px"}
        }, {
          bodyCell: _withCtx(({ column, record }) => [
            (column.key === 'goods_image')
              ? (_openBlock(), _createBlock(_component_a_image, {
                  key: 0,
                  src: record.goods_image,
                  style: {"width":"50px"}
                }, null, 8, ["src"]))
              : _createCommentVNode("", true),
            (column.key === 'shop_logo')
              ? (_openBlock(), _createBlock(_component_a_image, {
                  key: 1,
                  src: record.shop_logo,
                  style: {"width":"50px"}
                }, null, 8, ["src"]))
              : _createCommentVNode("", true),
            (column.key === 'comment_image')
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.comment_image, (item) => {
                    return (_openBlock(), _createBlock(_component_a_image, {
                      key: item,
                      src: item,
                      style: {"width":"50px","margin-right":"10px"}
                    }, null, 8, ["src"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (column.key === 'action')
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (record.status == 1)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 0,
                        size: "small",
                        style: {"margin":"5px"},
                        onClick: ($event: any) => ($setup.onStatus(record))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  (record.status == 0)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 1,
                        size: "small",
                        style: {"margin":"5px"},
                        onClick: ($event: any) => ($setup.onStatus(record))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_a_popconfirm, {
                    title: "是否删除该评论?",
                    onConfirm: ($event: any) => ($setup.onDel(record))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        size: "small",
                        style: {"margin":"5px"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["dataSource", "columns", "pagination", "onChange"])
      ]),
      _: 1
    })
  ]))
}